import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues, Form, Field, reduxForm, FormSection, submit } from 'redux-form';
import { FORM_ID } from '../../../../../framework/App/AppConstants';
import { saveDataInSession } from '../../../../../framework/store/ServerData/ServerDataActions';
import IBAN from '../../../../components/IBAN/IBAN';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import './RepaymentPageForm.less';
import CancelUrl, { COMPONENT_STYLE } from '../../../../components/CancelUrl/CancelUrl';
import Button, {BUTTON_STYLE} from '../../../../../shared-components/Button/Button';
import CheckBox from '../../../../../shared-components/CheckBox/CheckBox';
import SelectField, { mapOptionsToSelectField } from '../../../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../../../shared-components/FormElement/FormElementUtils';
import { push } from 'connected-react-router';
import { PAGE_NAME } from '../../../../config/DEConstants';
import { getInitialPersonalInfoValues } from '../../../../config/form';
import PropTypes from 'prop-types';
import {submitRepaymentValues} from './RepaymentPageFormActions';
import { trackTransition } from '../../../../../framework/store/FPTI/FPTIActions';


const LOCALE_PREFIX = 'DE/pages/RepaymentPage/RepaymentPage';


export class RepaymentPageForm extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        onFormSubmit: PropTypes.func.isRequired,
        onClickContinue: PropTypes.func.isRequired,
        handleClickContinue: PropTypes.func,
        repaymentFundingOptions: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    handleClickContinue = () => {
        const { onClickContinue, handleClickContinue } = this.props;
        return onClickContinue();
    }

    onFormSubmit = (formValues) => {
        const { onFormSubmit, intl } = this.props;
        return onFormSubmit(formValues, intl);
    };

    render() {
        const {
            intl,
            handleSubmit,
            repaymentFundingOptions
        } = this.props;

        const termsLabel = (
            <p>
                <FormattedMessage id={`${LOCALE_PREFIX}.agreeToSepa-text`} />
            </p>
        );

        let repaymentMethod;
        if (_.isEmpty(repaymentFundingOptions)) {
            repaymentMethod = (
                <div>
                    <IBAN placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.bmlIbanPlaceHolder`})} />

                    <Field
                        id="terms"
                        name="terms"
                        label={termsLabel}
                        validate={isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.agreeToSepa-contractError`}))}
                        component={CheckBox}
                    />
                </div>
            );
        } else {
            repaymentMethod = (
                <div>
                    <Field
                        id="bankName"
                        name="bankName"
                        component={SelectField}
                        hideLabel={true}
                        optionList={mapOptionsToSelectField(repaymentFundingOptions)}
                        required={true}
                        validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.bmlBankEmpty`}))]}
                    />
                </div>
            );
        }


        return (

            <div className="formWrapper">
                <Form
                    action="repayment"
                    id="RepaymentPageForm"
                    method="post"
                    className="proceed mainForm bmlApplyHappy"
                    onSubmit={handleSubmit(this.onFormSubmit)}
                >
                    <FormSection name="bank-info">

                        <p className="vx_text-body-md_medium">
                            <FormattedMessage className="alpha border-top" id={`${LOCALE_PREFIX}.bmlWithdrawnAutomatically`} />
                        </p>

                        {repaymentMethod}

                    </FormSection>

                    <div className="buttons">
                        <div id="action-buttons" className="vx_btn-group">
                            <Button
                                data-automation-id="continue"
                                btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                id="repaymentContinueBtn"
                                onClick={this.handleClickContinue}
                            >
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.continueApplication`}
                                />
                            </Button>
                            <CancelUrl
                                componentType={COMPONENT_STYLE.LINK_BUTTON}
                                fptiEvent={{
                                    stateName: 'pp_credit_repaymentpage',
                                    transitionName: 'cancel_pp_credit_repaymentpage'
                                }}
                                customLabel={`${LOCALE_PREFIX}.cancelApplication`}
                            />
                        </div>
                    </div>
                </Form>

            </div>
        );
    }
}

export const mapStateToProps = state => {
    const initialValues = getInitialPersonalInfoValues(state);
    return {
        formValues: getFormValues(FORM_ID)(state),
        repaymentFundingOptions: _.get(state, 'serverData.repaymentFundingOptions', []),
        initialValues : Object.assign(initialValues,
            {
                telephone: '',
                'bank-info': {
                    bankName: (Object.keys(_.get(state, 'serverData.repaymentFundingOptions', {})).length > 0) ?
                        Object.keys(_.get(state, 'serverData.repaymentFundingOptions'))[0] : ''
                }
            })
    };
};

export const mapDispatchToProps = dispatch => ({
    onClickContinue() {
        dispatch(submit(FORM_ID));
    },

    // handleSubmit will call this function if field validation passes.
    // formValues are passed by handleSubmit per api specification
    onFormSubmit(formValues, intl) {
        dispatch(trackTransition('pp_credit_repaymentpage', 'process_pp_credit_repaymentpage'));
        return dispatch(submitRepaymentValues(formValues, intl));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(RepaymentPageForm)
));
